import React from "react";
import { Link, withRouter } from "react-router-dom";
import { InputElement } from "../../shared/FormElements";

const ResetPassword = props => {
  if (props.sucessState) {
    props.lazyLoadComponent(props.nextPage);
  }
  const sendApiHit = () => {
    props.sucessHandler(props.formName);
  };
  const resetPasswordStructure = props.form.map((value, index) => (
    <div
      key={value + index}
      className="d-flex justify-content-center  no-gutter"
    >
      <InputElement
        name={value.id}
        type={value.config.type}
        class="mb-3 col-12 form-group mt-20"
        label={value.config.label}
        required={value.config.validation.require}
        value={value.config.value}
        onChangeHandler={props.onChangeHandler}
        formName={props.formName}
        onBlurHandler={props.onBlurHandler}
        errorMsg={value.config.errorMsg}
        valid={value.config.valid}
        maxLength={value.config.maxLength}
      />
    </div>
  ));
  return (
    <div>
      <div className="text-center mt50">
        {props.message && <p className="error">{props.message}</p>}
        <h3>Reset your password</h3>
        <p className="subHeading">
          Enter the email associated with your ausbiz account, and we'll send
          you a link to reset your password.
        </p>
      </div>

      <div>{resetPasswordStructure}</div>

      <div className="button-inline mt75">
        <Link to="/" className="btn btn-outline-secondary">
          Cancel
        </Link>
        <button
          type="button"
          className="btn"
          disabled={props.btnDisabled ? "disabled" : ""}
          onClick={() => sendApiHit()}
        >
          Reset
        </button>
      </div>
    </div>
  );
};

export default withRouter(ResetPassword);
